// extracted by mini-css-extract-plugin
export default {"dataItemsUsedInGfunctions":"warningDeleteDatasetModal_dataItemsUsedInGfunctions__Ygk2F","deleteDatasetModal":"warningDeleteDatasetModal_deleteDatasetModal__5sPg9"};